(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["foodpaket-alle-rezepte"] && !Shopify.designMode) return;
  try {
    
if (!window.foodpaketAllRecipes) {
  window.foodpaketAllRecipes = true;
  const states = new WeakMap();
  function normalizeSearch(value) {
    return String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ı/g,'i').replace(/ß/g,'ss');
  }
  function matchingArticles(state) {
    const terms=normalizeSearch(state.query).trim().split(/\s+/).filter(Boolean);
    return state.items.filter(item => (state.selected==='all'||item.blogId===state.selected) && terms.every(term => item.searchText.includes(term)));
  }
  function mergeArticles(groups) {
    const unique = new Map();
    groups.flat().forEach(item => { if (!unique.has(String(item.id))) unique.set(String(item.id),item); });
    return [...unique.values()].sort((a,b) => (Date.parse(b.publishedAt)||0)-(Date.parse(a.publishedAt)||0) || String(a.id).localeCompare(String(b.id)));
  }
  async function readBlog(button) {
    let page=1;
    const records=[];
    while(page !== null) {
      const url=new URL(button.dataset.blogUrl,location.origin);
      url.searchParams.set('view','foodpaket-all-recipes');url.searchParams.set('page',String(page));
      const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
      if(url.origin!==location.origin)throw new Error('Invalid origin');
      const response=await fetch(url.href,{credentials:'same-origin'});
      if(!response.ok)throw new Error('Request failed');
      const data=await response.json();
      if(data.format!=='foodpaket-all-recipes-v1'||data.page!==page||!Array.isArray(data.articles))throw new Error('Feed missing');
      if(data.nextPage!==null&&(!Number.isInteger(data.nextPage)||data.nextPage<=page))throw new Error('Invalid pagination');
      records.push(...data.articles.map(item=>({...item,blogId:button.dataset.fparFilter,blogLabel:button.dataset.blogLabel})));
      page=data.nextPage;
    }
    return records;
  }
  function render(root) {
    const state=states.get(root);
    const matching=matchingArticles(state);
    const visible=matching.slice(0,state.visible);
    const template=root.querySelector('[data-fpar-card]');
    const fragment=document.createDocumentFragment();
    visible.forEach(item=>{
      const card=template.content.firstElementChild.cloneNode(true);
      card.querySelectorAll('a').forEach(link=>link.href=item.url);
      card.querySelector('.fpar__image').setAttribute('aria-label',item.title);
      card.querySelector('h2 a').textContent=item.title;
      card.querySelector('.fpar__source').textContent=item.blogLabel;
      const excerpt=card.querySelector('.fpar__excerpt');if(excerpt)excerpt.textContent=item.excerpt;
      if(item.image){const img=document.createElement('img');img.src=item.image;img.alt=item.title;img.loading='lazy';img.width=900;img.height=563;card.querySelector('.fpar__image').replaceChildren(img);}
      fragment.append(card);
    });
    root.querySelector('[data-fpar-grid]').replaceChildren(fragment);
    root.querySelector('[data-fpar-more]').hidden=visible.length>=matching.length;
    let status=matching.length?visible.length+' von '+matching.length+' Beiträgen angezeigt.':'Hier gibt es noch keine veröffentlichten Beiträge.';
    if(state.query.trim()) status=matching.length ? visible.length+' von '+matching.length+' passenden Rezepten angezeigt.' : 'Keine passenden Rezepte gefunden. Probiere einen anderen Suchbegriff oder wähle einen anderen Blog.';
    if(state.busy) status+=' Weitere Rezepte werden geladen …';
    if(state.failed.length) status+=' Nicht alle Blogs konnten geladen werden: '+state.failed.map(b=>b.dataset.blogLabel).join(', ')+'. Bitte erneut versuchen oder die Blogübersichten unten öffnen.';
    root.querySelector('[data-fpar-status]').textContent=status;
    const linkArea=root.querySelector('[data-fpar-blog-link]');linkArea.replaceChildren();linkArea.hidden=state.selected==='all';
    if(state.selected!=='all') {const button=state.blogs.find(b=>b.dataset.fparFilter===state.selected);const link=document.createElement('a');link.href=button.dataset.blogUrl;link.textContent='Zur Blogübersicht „'+button.dataset.blogLabel+'“ →';linkArea.append(link);}
  }
  async function load(root) {
    const state=states.get(root);if(state.busy)return;state.busy=true;
    root.setAttribute('aria-busy','true');root.querySelector('[data-fpar-retry]').hidden=true;
    root.querySelector('[data-fpar-status]').textContent='Alle veröffentlichten Rezepte werden geladen …';
    try {
      const results=await Promise.allSettled(state.blogs.map(readBlog));
      state.failed=[];
      results.forEach((r,i)=>{if(r.status==='fulfilled')state.loaded.set(state.blogs[i].dataset.fparFilter,r.value);else state.failed.push(state.blogs[i]);});
      state.items=mergeArticles([...state.loaded.values()]).map(item=>({...item,searchText:normalizeSearch([item.title,item.excerpt].join(' '))}));
      state.busy=false;render(root);root.querySelector('[data-fpar-retry]').hidden=!state.failed.length;
    } finally {state.busy=false;root.removeAttribute('aria-busy');}
  }
  function init(scope=document) {
    const roots=[...(scope.matches&&scope.matches('[data-fpar]')?[scope]:[]),...scope.querySelectorAll('[data-fpar]')];
    roots.forEach(root=>{
      if(states.has(root))return;
      const blogs=[...root.querySelectorAll('[data-blog-url]')].filter((b,i,list)=>list.findIndex(x=>x.dataset.fparFilter===b.dataset.fparFilter)===i);
      states.set(root,{blogs,selected:'all',query:'',visible:Number(root.dataset.pageSize)||6,items:[],loaded:new Map(),failed:[],busy:false});
      if(!blogs.length){root.querySelector('[data-fpar-status]').textContent='Füge im Theme-Editor Blog-Blöcke hinzu und wähle deine Rezeptblogs aus.';return;}
      load(root);
    });
  }
  document.addEventListener('input',event=>{
    if(!(event.target instanceof Element)||!event.target.matches('[data-fpar-search]'))return;
    const root=event.target.closest('[data-fpar]');
    if(!root||!states.has(root))return;
    const state=states.get(root);
    state.query=event.target.value;state.visible=Number(root.dataset.pageSize)||6;
    root.querySelector('[data-fpar-clear]').hidden=!state.query;
    render(root);
  });
  document.addEventListener('click',event=>{
    if(!(event.target instanceof Element))return;
    const root=event.target.closest('[data-fpar]');if(!root||!states.has(root))return;
    const state=states.get(root);
    if(event.target.closest('[data-fpar-clear]')){
      const input=root.querySelector('[data-fpar-search]');
      input.value='';state.query='';state.visible=Number(root.dataset.pageSize)||6;
      root.querySelector('[data-fpar-clear]').hidden=true;render(root);input.focus();
    }
    const filter=event.target.closest('[data-fpar-filter]');
    if(filter){state.selected=filter.dataset.fparFilter;state.visible=Number(root.dataset.pageSize)||6;root.querySelectorAll('[data-fpar-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===filter)));render(root);}
    if(event.target.closest('[data-fpar-more]')){state.visible+=Number(root.dataset.pageSize)||6;render(root);}
    if(event.target.closest('[data-fpar-retry]'))load(root);
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foodpaket-blog"] && !Shopify.designMode) return;
  try {
    
if (!window.foodpaketBlogEvents) {
  window.foodpaketBlogEvents = true;
  const pending = new WeakSet();
  document.addEventListener('click', async event => {
    if (!(event.target instanceof Element)) return;
    const slide = event.target.closest('[data-fpb-section] [data-fpb-slide]');
    if (slide) {
      const track = slide.closest('.fpb__shop').querySelector('.fpb__products');
      track.scrollBy({left: Number(slide.dataset.fpbSlide) * track.clientWidth * .85, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      return;
    }
    const link = event.target.closest('[data-fpb-section] [data-fpb-more]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    const root = link.closest('[data-fpb-section]');
    if (pending.has(root)) return;
    pending.add(root);
    const status = root.querySelector('[data-fpb-status]');
    const before = status.dataset.baseStatus || status.textContent;
    status.dataset.baseStatus = before;
    link.setAttribute('aria-disabled', 'true');
    root.querySelector('[data-fpb-results]').setAttribute('aria-busy', 'true');
    status.textContent = 'Weitere Beiträge werden geladen …';
    try {
      const url = new URL(link.href);
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      if (url.origin !== window.location.origin) throw new Error('Unexpected origin');
      const response = await fetch(url.href, {credentials:'same-origin'});
      if (!response.ok) throw new Error('Request failed');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextRoot = parsed.getElementById(root.id);
      if (!nextRoot) throw new Error('Section missing');
      const cards = [...nextRoot.querySelectorAll('[data-fpb-card]')];
      const nextPagination = nextRoot.querySelector('[data-fpb-pagination]');
      if (!cards.length || !nextPagination) throw new Error('No articles');
      const firstLink = cards[0].querySelector('a');
      const grid = root.querySelector('[data-fpb-grid]');
      cards.forEach(card => grid.append(document.importNode(card, true)));
      const pagination = root.querySelector('[data-fpb-pagination]');
      const nextLink = nextPagination.querySelector('[data-fpb-more]');
      pagination.replaceChildren();
      if (nextLink) pagination.append(document.importNode(nextLink,true));
      status.textContent = before + ' · ' + grid.querySelectorAll('[data-fpb-card]').length + ' Beiträge angezeigt.';
      // Move focus to the newly loaded content when the clicked link was replaced.
      if (firstLink) grid.children[grid.children.length - cards.length].querySelector('a').focus({preventScroll:true});
    } catch (_) {
      status.textContent = 'Laden nicht möglich. Öffne die nächste Seite über diesen Link.';
      link.textContent = 'Nächste Seite öffnen →';
      link.removeAttribute('data-fpb-more');
    } finally {
      pending.delete(root);
      link.removeAttribute('aria-disabled');
      root.querySelector('[data-fpb-results]').removeAttribute('aria-busy');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foodpaket-rezept-artikel"] && !Shopify.designMode) return;
  try {
    
if (!window.foodpaketRecipeArticleConsentEvents) {
  window.foodpaketRecipeArticleConsentEvents = true;
  const serviceId = 'SyUQ54odobQ';
  const states = new Map();
  let revision = 0;
  function state(card) {
    if (!states.has(card)) states.set(card, {preview: card.innerHTML, requested: false, busy: false});
    return states.get(card);
  }
  function notice(card, text) {
    const node = card.closest('.fpa__video-card').querySelector('[data-fpa-status]');
    if (node) node.textContent = text;
  }
  async function cmp() {
    const api = window.__ucCmp;
    if (!api || typeof api.getConsentDetails !== 'function' || !(await api.isInitialized())) {
      throw new Error('Die Datenschutzeinstellungen sind noch nicht verfügbar. Bitte versuche es gleich erneut.');
    }
    return api;
  }
  async function service(api) {
    const details = await api.getConsentDetails();
    const entry = details.services && details.services[serviceId];
    if (!entry) throw new Error('Instagram ist aktuell nicht in den Datenschutzeinstellungen verfügbar. Du kannst das Video über den Instagram-Link öffnen.');
    return entry;
  }
  function embedUrl(card) {
    const button = card.querySelector('[data-fpa-instagram]');
    const url = new URL(button.dataset.fpaInstagram);
    const match = url.pathname.match(/^\/(p|reel)\/([A-Za-z0-9_-]+)\/?$/);
    if (url.protocol !== 'https:' || !['instagram.com', 'www.instagram.com'].includes(url.hostname) || !match) {
      throw new Error('Der Video-Link ist ungültig. Bitte verwende den Instagram-Link unter dem Video.');
    }
    return 'https://www.instagram.com/' + match[1] + '/' + match[2] + '/embed/';
  }
  function reset(card) {
    const saved = state(card);
    card.innerHTML = saved.preview;
    card.classList.remove('fpa__video--loaded');
  }
  function mount(card, src) {
    if (card.classList.contains('fpa__video--loaded')) return;
    const frame = document.createElement('iframe');
    frame.title = 'Rezeptvideo auf Instagram';
    frame.allowFullscreen = true;
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    frame.src = src;
    card.replaceChildren(frame);
    card.classList.add('fpa__video--loaded');
    notice(card, 'Instagram wurde erlaubt. Falls das Video nicht erscheint, kannst du es direkt auf Instagram ansehen.');
  }
  async function sync() {
    const current = ++revision;
    try {
      const api = await cmp();
      const entry = await service(api);
      if (current !== revision) return;
      states.forEach((saved, card) => {
        if (!card.isConnected) { states.delete(card); return; }
        if (saved.busy) return;
        if (!entry.consent || entry.consent.given !== true) {
          if (card.classList.contains('fpa__video--loaded')) reset(card);
          notice(card, 'Instagram ist deaktiviert. Du kannst es hier gezielt erlauben.');
        } else if (saved.requested) {
          mount(card, embedUrl(card));
        }
      });
    } catch (_) {
      states.forEach((saved, card) => {
        if (!saved.busy && card.classList.contains('fpa__video--loaded')) {
          reset(card);
          notice(card, 'Die Instagram-Zustimmung konnte nicht geprüft werden. Bitte versuche es erneut.');
        }
      });
    }
  }
  document.addEventListener('click', async function(event) {
    if (!(event.target instanceof Element)) return;
    const settings = event.target.closest('.fpa [data-fpa-consent-settings]');
    const button = event.target.closest('.fpa [data-fpa-instagram]');
    if (!settings && !button) return;
    const card = (settings || button).closest('.fpa__video-card').querySelector('[data-fpa-video]');
    const saved = state(card);
    if (saved.busy) return;
    saved.busy = true;
    if (button) button.disabled = true;
    try {
      const api = await cmp();
      if (settings) {
        await api.showServiceDetails(serviceId);
      } else {
        const src = embedUrl(card);
        saved.requested = true;
        const entry = await service(api);
        if (!entry.consent || entry.consent.given !== true) {
          notice(card, 'Deine Instagram-Zustimmung wird gespeichert …');
          await api.updateServicesConsents([{id: serviceId, consent: true}]);
          await api.saveConsents('EXPLICIT');
        }
        const confirmed = await service(api);
        if (!confirmed.consent || confirmed.consent.given !== true) throw new Error('Die Zustimmung wurde nicht gespeichert. Bitte öffne die Instagram-Datenschutzeinstellungen.');
        mount(card, src);
      }
    } catch (error) {
      notice(card, error.message || 'Das Video konnte nicht geladen werden. Bitte versuche es erneut.');
    } finally {
      saved.busy = false;
      if (button && button.isConnected) button.disabled = false;
    }
  });
  window.addEventListener('UC_CONSENT', sync);
  window.addEventListener('UC_UI_INITIALIZED', sync);
  window.addEventListener('focus', sync);
}


// Linkziel anhand der Zutatenüberschrift im jeweiligen Artikel setzen.
if (!window.foodpaketRecipeIngredientLinks) {
  window.foodpaketRecipeIngredientLinks = true;
  function updateIngredientLinks() {
    document.querySelectorAll('.fpa').forEach(function(article) {
      const content = article.querySelector('.fpa__content');
      const link = article.querySelector('.fpa__actions .fpa__button');
      if (!content || !link) return;
      const heading = Array.from(content.querySelectorAll('h2, h3, h4')).find(function(node) {
        return /^zutaten\b/i.test(node.textContent.trim());
      });
      if (!heading) { link.setAttribute('href', '#' + content.id); return; }
      if (!heading.id) heading.id = article.id + '-ingredients';
      heading.classList.add('fpa__ingredients-anchor');
      link.setAttribute('href', '#' + heading.id);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateIngredientLinks);
  else updateIngredientLinks();
  document.addEventListener('shopify:section:load', updateIngredientLinks);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yayla-rezepte"] && !Shopify.designMode) return;
  try {
    

if (!window.foodpaketRecipeClickHandler) {
  window.foodpaketRecipeClickHandler = true;
  const normalizeTag = value => String(value).normalize('NFKC').trim().replace(/\s+/g, ' ').toLocaleLowerCase('de-DE');

  const blogStates = new WeakMap();
  function getState(area) {
    if (!blogStates.has(area)) blogStates.set(area, {
      selected: '__all', visible: Number(area.dataset.pageSize) || 6,
      template: area.querySelector('.fpr__article').cloneNode(true), request: 0, promise: null
    });
    return blogStates.get(area);
  }
  async function readBlog(area, state) {
    if (!state.promise) state.promise = (async () => {
      const all = [], seen = new Set();
      let page = 1;
      while (page) {
        const url = new URL(area.dataset.blogUrl, window.location.origin);
        url.searchParams.set('view', 'foodpaket-recipe-feed');
        url.searchParams.set('page', page);
        const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url.href, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Blog request failed');
        const data = await response.json();
        if (data.format !== 'foodpaket-recipes-v1' || data.page !== page || !Array.isArray(data.articles)) throw new Error('Missing feed template');
        for (const item of data.articles) {
          if (!seen.has(item.id)) { seen.add(item.id); all.push(item); }
        }
        if (data.nextPage !== null && (!Number.isInteger(data.nextPage) || data.nextPage <= page)) throw new Error('Invalid pagination');
        page = data.nextPage;
      }
      return all;
    })().catch(error => { state.promise = null; throw error; });
    return state.promise;
  }
  function makeCard(item, template) {
    const card = template.cloneNode(true);
    card.hidden = false;
    card.dataset.recipeTags = JSON.stringify(item.tags);
    card.querySelectorAll('a').forEach(link => link.setAttribute('href', item.url));
    const imageLink = card.querySelector('.fpr__article-image');
    imageLink.setAttribute('aria-label', item.title);
    imageLink.replaceChildren();
    if (item.image) {
      const img = document.createElement('img');
      img.src = item.image; img.alt = item.title; img.loading = 'lazy';
      img.width = 900; img.height = 675;
      imageLink.append(img);
    } else {
      const placeholder = document.createElement('div');
      placeholder.className = 'fpr__placeholder';
      const label = document.createElement('p'); label.textContent = item.title;
      placeholder.append(label); imageLink.append(placeholder);
    }
    card.querySelector('h3 a').textContent = item.title;
    const excerpt = card.querySelector('.fpr__excerpt');
    if (excerpt) excerpt.textContent = item.excerpt;
    return card;
  }
  function renderBlog(area, state, items) {
    const matches = state.selected === '__all' ? items : items.filter(item =>
      Array.isArray(item.tags) && item.tags.some(tag => normalizeTag(tag) === normalizeTag(state.selected)));
    const visible = matches.slice(0, state.visible);
    const grid = area.querySelector('.fpr__recipe-grid');
    const fragment = document.createDocumentFragment();
    visible.forEach(item => fragment.append(makeCard(item, state.template)));
    grid.replaceChildren(fragment);
    area.querySelector('[data-filter-status]').textContent = matches.length
      ? visible.length + ' von ' + matches.length + ' Rezepten angezeigt.'
      : 'Für diese Kategorie gibt es noch keine Rezepte.';
    const more = area.querySelector('[data-recipe-more]');
    if (more) more.hidden = visible.length >= matches.length;
  }
  document.addEventListener('click', async function(event) {
    const filterButton = event.target.closest('.fpr [data-recipe-filter]');
    const moreButton = event.target.closest('.fpr [data-recipe-more]');
    if (filterButton || moreButton) {
      const area = (filterButton || moreButton).closest('.fpr__articles');
      if (filterButton) area.querySelectorAll('[data-recipe-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === filterButton)));
      if (area.dataset.blogUrl) {
        const state = getState(area);
        const pageSize = Number(area.dataset.pageSize) || 6;
        if (filterButton) { state.selected = filterButton.dataset.recipeFilter; state.visible = pageSize; }
        else state.visible += pageSize;
        const request = ++state.request;
        area.setAttribute('aria-busy', 'true');
        area.querySelector('[data-filter-status]').textContent = 'Rezepte werden geladen …';
        try {
          const items = await readBlog(area, state);
          if (request === state.request) renderBlog(area, state, items);
        } catch (error) {
          if (request === state.request) {
            area.querySelector('[data-filter-status]').textContent = 'Die vollständige Rezeptsammlung konnte nicht geladen werden. Bitte versuche es erneut oder öffne den Blog über den Link unten.';
          }
        } finally { if (request === state.request) area.removeAttribute('aria-busy'); }
      } else if (filterButton) {
        const chosen = filterButton.dataset.recipeFilter;
        let shown = 0;
        area.querySelectorAll('[data-recipe-tags]').forEach(card => {
          let tags = [];
          try { tags = JSON.parse(card.dataset.recipeTags); } catch (error) { /* No tags available. */ }
          if (!Array.isArray(tags)) tags = [];
          card.hidden = chosen !== '__all' && !tags.some(tag => normalizeTag(tag) === normalizeTag(chosen));
          if (!card.hidden) shown++;
        });
        area.querySelector('[data-filter-status]').textContent = shown ? shown + ' Rezepte angezeigt.' : 'In dieser Auswahl gibt es noch keine passenden Rezepte.';
      }
      return;
    }

  });
}

if (!window.foodpaketRecipeLandingConsentEvents) {
  window.foodpaketRecipeLandingConsentEvents = true;
  const serviceId = 'SyUQ54odobQ';
  const states = new Map();
  let revision = 0;
  function state(card) {
    if (!states.has(card)) states.set(card, {preview: card.innerHTML, requested: false, busy: false, src: null});
    return states.get(card);
  }
  function notice(card, text) {
    const node = card.closest('.fpr__recipe').querySelector('[data-fpr-status]');
    if (node) node.textContent = text;
  }
  async function cmp() {
    const api = window.__ucCmp;
    if (!api || typeof api.getConsentDetails !== 'function' || !(await api.isInitialized())) {
      throw new Error('Die Datenschutzeinstellungen sind noch nicht verfügbar. Bitte versuche es gleich erneut.');
    }
    return api;
  }
  async function service(api) {
    const details = await api.getConsentDetails();
    const entry = details.services && details.services[serviceId];
    if (!entry) throw new Error('Instagram ist aktuell nicht in den Datenschutzeinstellungen verfügbar. Du kannst das Video über den Instagram-Link öffnen.');
    return entry;
  }
  function embedUrl(card) {
    const button = card.querySelector('[data-instagram]');
    const url = new URL(button.dataset.instagram);
    const match = url.pathname.match(/^\/(p|reel)\/([A-Za-z0-9_-]+)\/?$/);
    if (url.protocol !== 'https:' || !['instagram.com', 'www.instagram.com'].includes(url.hostname) || !match) {
      throw new Error('Der Video-Link ist ungültig. Bitte verwende den Instagram-Link unter dem Video.');
    }
    return 'https://www.instagram.com/' + match[1] + '/' + match[2] + '/embed/';
  }
  function reset(card) {
    const saved = state(card);
    card.innerHTML = saved.preview;
    card.classList.remove('fpr__video--loaded');
  }
  function mount(card, src) {
    if (card.classList.contains('fpr__video--loaded')) return;
    const frame = document.createElement('iframe');
    frame.title = 'Rezeptvideo auf Instagram';
    frame.allowFullscreen = true;
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    frame.src = src;
    card.replaceChildren(frame);
    card.classList.add('fpr__video--loaded');
    notice(card, 'Instagram wurde erlaubt. Falls das Video nicht erscheint, kannst du es direkt auf Instagram ansehen.');
  }
  async function sync() {
    const current = ++revision;
    try {
      const api = await cmp();
      const entry = await service(api);
      if (current !== revision) return;
      states.forEach((saved, card) => {
        if (!card.isConnected) { states.delete(card); return; }
        if (saved.busy) return;
        if (!entry.consent || entry.consent.given !== true) {
          if (card.classList.contains('fpr__video--loaded')) reset(card);
          notice(card, 'Instagram ist deaktiviert. Du kannst es hier gezielt erlauben.');
        } else if (saved.requested) {
          mount(card, saved.src);
        }
      });
    } catch (_) {
      states.forEach((saved, card) => {
        if (!saved.busy && card.classList.contains('fpr__video--loaded')) {
          reset(card);
          notice(card, 'Die Instagram-Zustimmung konnte nicht geprüft werden. Bitte versuche es erneut.');
        }
      });
    }
  }
  document.addEventListener('click', async function(event) {
    if (!(event.target instanceof Element)) return;
    const settings = event.target.closest('.fpr [data-fpr-consent-settings]');
    const button = event.target.closest('.fpr [data-instagram]');
    if (!settings && !button) return;
    const card = (settings || button).closest('.fpr__recipe').querySelector('[data-video-card]');
    const saved = state(card);
    if (saved.busy) return;
    saved.busy = true;
    if (button) button.disabled = true;
    try {
      const api = await cmp();
      if (settings) {
        await api.showServiceDetails(serviceId);
      } else {
        const src = embedUrl(card);
        saved.requested = true;
        saved.src = src;
        const entry = await service(api);
        if (!entry.consent || entry.consent.given !== true) {
          notice(card, 'Deine Instagram-Zustimmung wird gespeichert …');
          await api.updateServicesConsents([{id: serviceId, consent: true}]);
          await api.saveConsents('EXPLICIT');
        }
        const confirmed = await service(api);
        if (!confirmed.consent || confirmed.consent.given !== true) throw new Error('Die Zustimmung wurde nicht gespeichert. Bitte öffne die Instagram-Datenschutzeinstellungen.');
        mount(card, src);
      }
    } catch (error) {
      notice(card, error.message || 'Das Video konnte nicht geladen werden. Bitte versuche es erneut.');
    } finally {
      saved.busy = false;
      if (button && button.isConnected) button.disabled = false;
    }
  });
  window.addEventListener('UC_CONSENT', sync);
  window.addEventListener('UC_UI_INITIALIZED', sync);
  window.addEventListener('focus', sync);
}


  } catch(e) { console.error(e); }
})();
})();
